import { Cookies } from 'react-cookie';

import { HubDetailPageApiResponse } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getHubDetailPageData = async (slug: string) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get(`/hub/${slug}/detail`, {
    headers: {
      Authorization: token,
    },
  });
  return data.data as HubDetailPageApiResponse;
};
